import React, { useState } from 'react';
import { Box, Tab, Tabs, Typography } from '@mui/material';
import AccountsTab from './AccountsTab';
import TierPoolsTab from './TierPoolsTab';
import BranchManagersTab from './BranchManagersTab';

/* Multi-banking admin: manage bank accounts (UPI/IMPS/NEFT/…), pool them onto
   tiers, and create branch-portal logins. Deposits/withdrawals are routed to a
   user's tier+branch account so a flagged account can't take down everyone. */
export default function BankingPage() {
  const [tab, setTab] = useState(0);
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h5" fontWeight={700}>Banking</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Multi-bank accounts, tier account pools, and branch logins
      </Typography>
      <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ mb: 2, borderBottom: 1, borderColor: 'divider' }}>
        <Tab label="Accounts" />
        <Tab label="Tier Pools" />
        <Tab label="Branch Managers" />
      </Tabs>
      {tab === 0 && <AccountsTab />}
      {tab === 1 && <TierPoolsTab />}
      {tab === 2 && <BranchManagersTab />}
    </Box>
  );
}
